<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules" style="margin-bottom: 60px">
			<el-divider content-position="left">基础信息</el-divider>
			<el-form-item label="所属门店：" prop="belongStoreKeyId">
				<el-select filterable v-model="editForm.belongStoreKeyId" placeholder="请选择门店" clearable size="small" class="input_200px" @change="handleChangeStore">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="客户姓名" prop="name">
				<el-input clearable v-model="editForm.name" class="input_200px" size="small" auto-complete="off" placeholder="请输入客户姓名"></el-input>
			</el-form-item>
			<el-form-item label="电话" prop="phone">
				<el-input clearable v-model="editForm.phone" class="input_200px" size="small" auto-complete="off" placeholder="请输入电话"></el-input>
			</el-form-item>
			<el-form-item label="年龄" prop="age">
				<el-input v-model.number="editForm.age" class="input_200px" size="small" type="text" auto-complete="off" placeholder="请输入年龄"></el-input>
			</el-form-item>
			<el-form-item label="性别" prop="gender">
				<el-radio-group v-model="editForm.gender" class="input_200px">
					<el-radio-button :label="1">男</el-radio-button>
					<el-radio-button :label="0">女</el-radio-button>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="进店类型" prop="inStoreType">
				<el-select v-model="editForm.inStoreType" placeholder="请选择进店类型" clearable size="small" class="input_200px">
					<el-option v-for="item in inStoreTypeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="顾客类型" prop="customerType">
				<el-select v-model="editForm.customerType" placeholder="请选择顾客类型" clearable size="small" class="input_200px">
					<el-option v-for="item in customerTypeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="档案编号" prop="customerNo">
				<el-input clearable v-model="editForm.customerNo" class="input_200px" size="small" auto-complete="off" placeholder="请输入档案编号"></el-input>
			</el-form-item>
			<el-form-item label="接待人员" prop="employeeKeyIds">
				<el-select v-model="editForm.employeeKeyIds" placeholder="请选择接待人员" clearable filterable size="small" class="input_200px" multiple>
					<el-option v-for="item in receptionUserList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="学校名称" prop="schoolName">
				<el-input clearable v-model="editForm.schoolName" class="input_200px" size="small" auto-complete="off" placeholder="请输入学校名称"></el-input>
			</el-form-item>

			<el-divider content-position="left">右眼参数</el-divider>
			<el-form-item label="球镜" prop="rParams.qiuJing">
				<el-input clearable
					v-model="editForm.rParams.qiuJing"
					class="input_200px"
					size="small"
					type="text"
					auto-complete="off"
					placeholder="请输入球镜"
					step="0.25"
					:precision="2"
					@change="formatNestedNumber('rParams', 'qiuJing', $event)"
				></el-input>
			</el-form-item>
			<el-form-item label="柱镜" prop="rParams.zhuJing">
				<el-input clearable
					v-model="editForm.rParams.zhuJing"
					class="input_200px"
					size="small"
					type="text"
					auto-complete="off"
					placeholder="请输入柱镜"
					step="0.25"
					:precision="2"
					@change="formatNestedNumber('rParams', 'zhuJing', $event)"
				></el-input>
			</el-form-item>
			<el-form-item label="轴位" prop="rParams.zhouWei">
				<el-input clearable v-model="editForm.rParams.zhouWei" class="input_200px" size="small" type="text" auto-complete="off" placeholder="请输入轴位" step="1" min="0" max="180"></el-input>
			</el-form-item>
			<el-form-item label="瞳高" prop="rParams.tongGao">
				<el-input clearable v-model="editForm.rParams.tongGao" class="input_200px" size="small" type="text" auto-complete="off" placeholder="请输入瞳高" step="0.1"></el-input>
			</el-form-item>
			<el-form-item label="瞳距" prop="rParams.tongJu">
				<el-input clearable v-model="editForm.rParams.tongJu" class="input_200px" size="small" type="text" auto-complete="off" placeholder="请输入瞳距" step="0.1"></el-input>
			</el-form-item>
			<el-form-item label="矫正视力" prop="rParams.jiaoZhengShiLi">
				<el-input v-model="editForm.rParams.jiaoZhengShiLi" class="input_200px" size="small" type="number" auto-complete="off" placeholder="请输入矫正视力" step="0.1"></el-input>
			</el-form-item>

			<el-divider content-position="left">左眼参数</el-divider>
			<el-form-item label="球镜" prop="lParams.qiuJing">
				<el-input clearable
					v-model="editForm.lParams.qiuJing"
					class="input_200px"
					size="small"
					type="text"
					auto-complete="off"
					placeholder="请输入球镜"
					step="0.25"
					:precision="2"
					@change="formatNestedNumber('lParams', 'qiuJing', $event)"
				></el-input>
			</el-form-item>
			<el-form-item label="柱镜" prop="lParams.zhuJing">
				<el-input clearable
					v-model="editForm.lParams.zhuJing"
					class="input_200px"
					size="small"
					type="text"
					auto-complete="off"
					placeholder="请输入柱镜"
					step="0.25"
					:precision="2"
					@change="formatNestedNumber('lParams', 'zhuJing', $event)"
				></el-input>
			</el-form-item>
			<el-form-item label="轴位" prop="lParams.zhouWei">
				<el-input v-model="editForm.lParams.zhouWei" class="input_200px" size="small" type="number" auto-complete="off" placeholder="请输入轴位" min="0" max="180"></el-input>
			</el-form-item>
			<el-form-item label="瞳高" prop="lParams.tongGao">
				<el-input v-model="editForm.lParams.tongGao" class="input_200px" size="small" type="number" auto-complete="off" placeholder="请输入瞳高" step="0.1"></el-input>
			</el-form-item>
			<el-form-item label="瞳距" prop="lParams.tongJu">
				<el-input v-model="editForm.lParams.tongJu" class="input_200px" size="small" type="number" auto-complete="off" placeholder="请输入瞳距" step="0.1"></el-input>
			</el-form-item>
			<el-form-item label="矫正视力" prop="lParams.jiaoZhengShiLi">
				<el-input v-model="editForm.lParams.jiaoZhengShiLi" class="input_200px" size="small" type="number" auto-complete="off" placeholder="请输入矫正视力" step="0.1"></el-input>
			</el-form-item>
		</el-form>

		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" @click="submitForm('editForm')">保存</el-button>
			<el-button
				v-if="!editForm.isCreateVip && $checkBtnPermission('/customer/index', 'createVip') && editForm.keyId != ''"
				size="small"
				icon="el-icon-plus"
				:loading="loading"
				type="primary"
				@click="createVip()"
			>
				办理储值卡
			</el-button>
			<el-button
				v-if="editForm.isCreateVip && $checkBtnPermission('/customer/index', 'unbindVip') && editForm.keyId != ''"
				size="small"
				icon="el-icon-unlock"
				:loading="isSubmitting"
				type="warning"
				@click="handleUnbindVip()"
			>
				解绑会员卡
			</el-button>
			<el-button
				v-if="editForm.isCreateVip && $checkBtnPermission('/customer/index', 'changeVip') && editForm.keyId != ''"
				size="small"
				icon="el-icon-refresh"
				:loading="isSubmitting"
				type="primary"
				@click="openChangeVipCard()"
			>
				换卡
			</el-button>
		</div>
		<!-- 创建会员卡 -->
		<lcsj-dialog v-model="dialogVisible" title="创建会员卡" width="60%" cancel-text="取消" confirm-text="确认"
			 :confirm-loading="isSubmitting"
			 :close-on-click-modal="false"
			 append-to-body
			 @confirm="handleCreateVip">
			<span style="display: block; margin-bottom: 10px"><strong>会员卡号:</strong></span>
			<el-input clearable v-model="vipCardNumber" placeholder="请输入会员卡号" style="width: 100%" max-length="50"></el-input></lcsj-dialog>
		<!-- 换卡 -->
		<lcsj-dialog v-model="changeCardDialogVisible" title="更换会员卡" width="60%" cancel-text="取消" confirm-text="确认"
			 :confirm-loading="isSubmitting"
			 :close-on-click-modal="false"
			 append-to-body
			 @confirm="handleChangeVipCard">
			<span style="display: block; margin-bottom: 10px"><strong>新会员卡号:</strong></span>
			<el-input clearable v-model="changeCardForm.newVipNo" placeholder="请输入新会员卡号（门店内不存在将新建）" style="width: 100%" max-length="50"></el-input>
			<span style="display: block; margin: 10px 0"><strong>备注:</strong></span>
			<el-input v-model="changeCardForm.remark" type="textarea" :rows="2" placeholder="请输入换卡原因（选填）" max-length="200"></el-input></lcsj-dialog>
	</el-drawer>
</template>

<script>
import { saveCustomerInfo, getCustomerInfoDetail } from "@/api/baseDataApi.js";
import { GetOrganizationListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { AddCustomerVip, UnbindCustomerVip, ChangeVipCard } from "@/api/vipApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
export default {
	watch: {
		editFormVisible(visible) {
			if (!visible) return;
			this.GetEnumConfigListByCode();
			this.GetInStoreTypeList();
		}
	},
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				name: "",
				age: 20,
				gender: 1,
				phone: "",
				belongStoreKeyId: "",
				customerType: 1,
				customerNo: "",
				inStoreType: 1,
				employeeKeyIds: [],
				schoolName: "",
				lParams: {
					qiuJing: "",
					zhuJing: "",
					tongGao: "",
					tongJu: "",
					zhouWei: "",
					jiaoZhengShiLi: ""
				},
				rParams: {
					qiuJing: "",
					zhuJing: "",
					tongGao: "",
					tongJu: "",
					zhouWei: "",
					jiaoZhengShiLi: ""
				},
				isCreateVip: false
			},
			// rules 表单验证
			rules: {
				name: [
					{
						required: true,
						message: "请输入客户姓名",
						trigger: "blur"
					}
				],
				belongStoreKeyId: [
					{
						required: true,
						message: "请选择客户所属门店",
						trigger: "blur"
					}
				],
				phone: [
					{
						required: true,
						message: "请输入联系电话",
						trigger: "blur"
					},
					{
						pattern: /^1[3456789]\d{9}$/,
						message: "请输入正确的手机号",
						trigger: "blur"
					}
				],
				customerType: [
					{
						required: true,
						message: "请选择顾客类型",
						trigger: "blur"
					}
				],
				inStoreType: [
					{
						required: true,
						message: "请选择进店类型",
						trigger: "blur"
					}
				],
				customerNo: [
					{
						required: true,
						message: "请输入档案编号",
						trigger: "blur"
					}
				],
				age: [
					{
						required: true,
						message: "请输入年龄",
						trigger: "blur"
					}
				],
				gender: [
					{
						required: true,
						message: "请选择性别",
						trigger: "blur"
					}
				],
				employeeKeyIds: [
					{
						required: true,
						message: "请选择接待人员",
						trigger: "blur"
					}
				]
			},
			storeList: [],
			dialogVisible: false,
			vipCardNumber: "",
			isSubmitting: false,
			changeCardDialogVisible: false,
			changeCardForm: {
				newVipNo: "",
				remark: ""
			},
			customerTypeList: [],
			inStoreTypeList: [],
			receptionUserList: []
		};
	},
	created() {},
	mounted() {},
	components: {},
	methods: {
		//显示编辑界面
		editShow(row) {
			this.GetOrganizationListByConfig();
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				getCustomerInfoDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm.employeeKeyIds = [];
							this.GetUserBindSelectByPermission(res.data.belongStoreKeyId);
							this.editForm = res.data;
							if (res.data.receptionUserKeyIds) {
								this.editForm.employeeKeyIds = res.data.receptionUserKeyIds.split(",");
							}
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("客户信息获取失败!");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					this.loading = true;
					saveCustomerInfo(this.editForm)
						.then((res) => {
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "客户保存成功！"
								});
								this.editFormVisible = false;
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.$message.error("客户保存失败，请稍后再试！");
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		},
		// 获取所属门店
		GetOrganizationListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrganizationListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 格式化嵌套对象中的数字为两位小数
		formatNestedNumber(parent, field, value) {
			if (value !== "" && value !== null && value !== undefined) {
				this.$nextTick(() => {
					var val = parseFloat(value).toFixed(2);
					if (val > 0) {
						this.editForm[parent][field] = "+" + val;
					} else {
						this.editForm[parent][field] = val;
					}
				});
			}
		},
		// 创建会员
		createVip() {
			this.dialogVisible = true;
		},
		// 处理创建会员逻辑
		handleCreateVip() {
			const paramer = {
				keyId: this.editForm.keyId,
				VipNo: this.vipCardNumber
			};
			if (!this.vipCardNumber) {
				this.$message.error("请输入会员卡号！");
				return;
			}
			this.isSubmitting = true;
			AddCustomerVip(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "会员创建成功！"
						});
						this.dialogVisible = false;
						this.editFormVisible = false;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("会员创建失败，请稍后再试！");
				})
				.finally(() => {
					this.isSubmitting = false;
				});
		},
		// 刷新顾客详情（解绑/换卡后更新 isCreateVip 等状态）
		refreshDetail() {
			if (!this.editForm.keyId) return;
			getCustomerInfoDetail({ keyId: this.editForm.keyId })
				.then((res) => {
					if (res.code == 1) {
						let employeeKeyIds = [];
						if (res.data.receptionUserKeyIds) {
							employeeKeyIds = res.data.receptionUserKeyIds.split(",");
						}
						this.editForm = res.data;
						this.editForm.employeeKeyIds = employeeKeyIds;
					}
				})
				.catch((err) => {});
		},
		// 解绑会员卡
		handleUnbindVip() {
			this.$confirm("确认解绑该顾客的会员卡吗？解绑后该顾客将无法使用此卡。", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.isSubmitting = true;
					UnbindCustomerVip({ keyId: this.editForm.keyId })
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "解绑成功！"
								});
								this.refreshDetail();
								this.$parent.getListData();
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.$message.error("解绑失败，请稍后再试！");
						})
						.finally(() => {
							this.isSubmitting = false;
						});
				})
				.catch(() => {});
		},
		// 打开换卡弹窗
		openChangeVipCard() {
			this.changeCardForm = {
				newVipNo: "",
				remark: ""
			};
			this.changeCardDialogVisible = true;
		},
		// 确认换卡
		handleChangeVipCard() {
			if (!this.changeCardForm.newVipNo || !this.changeCardForm.newVipNo.trim()) {
				this.$message.error("请输入新会员卡号！");
				return;
			}
			this.isSubmitting = true;
			ChangeVipCard({
				keyId: this.editForm.keyId,
				newVipNo: this.changeCardForm.newVipNo.trim(),
				remark: this.changeCardForm.remark
			})
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "换卡成功！"
						});
						this.changeCardDialogVisible = false;
						this.refreshDetail();
						this.$parent.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("换卡失败，请稍后再试！");
				})
				.finally(() => {
					this.isSubmitting = false;
				});
		},
		// 获取顾客类型
		GetEnumConfigListByCode() {
			const paramer = {
				code: "CustomerType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.customerTypeList = [];
						res.data.forEach((item) => {
							this.customerTypeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取顾客类型信息失败!");
				});
		},
		// 获取进店类型
		GetInStoreTypeList() {
			const paramer = {
				code: "InStoreType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.inStoreTypeList = [];
						res.data.forEach((item) => {
							this.inStoreTypeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取进店类型信息失败!");
				});
		},
		// 获取人员信息绑定下拉框_根据权限
		GetUserBindSelectByPermission(storeKeyId) {
			const paramer = {
				isChargePerson: true
			};
			if (storeKeyId) {
				paramer.keyId = storeKeyId;
			}
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.receptionUserList = [];
						this.receptionUserList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取人员信息失败!");
				});
		},
		// 门店改变时，获取接待人员
		handleChangeStore(val) {
			if (!val) {
				this.$message.error("请选择门店！");
				return;
			}
			this.editForm.belongStoreKeyId = val;
			this.GetUserBindSelectByPermission(val);
		}
	}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
